<section class="content">
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fa fa-arrow-left" style="margin-right: 8px;"
            [routerLink]="['/dashboard/channel-partners']"></i>
            {{delear?.name}}
          </h3>
        </div>
        <div class="card-body" style="display: block;">
          <ul>
            <li>Contact: {{delear?.contact}}</li>
            <li>Firm name: {{delear?.company_name}}</li>
            <li>Email: {{delear?.email}}</li>
            <li>Comission: {{delear?.comission}}</li>
            <li>Rera Number: {{delear?.rera_number}}</li>
            <li>Associated Sales Officer: {{delear?.sales_officer?.name}}</li>
            <li>Address: {{delear?.address}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="row" *ngIf="toggle">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="input-group input-group-sm" style="width: 250px;">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default" id="btn" (click)="back();">
                <i class="fas fa-create"></i> Add New Broker
              </button>
            </div>

            <div class="input-group-append">
              <button type="submit" class="btn btn-default" (click)="export()">Export
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>

        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 300px;">
            <input type="text" name="table_search" [(ngModel)]="searchString" class="form-control float-right"
              placeholder="Search">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
      <div class="pt-2" *ngIf="subdelears.length == 0">
        <p class="text-center">No Sub Broker</p>
      </div>
      <div class="card-body table-responsive p-0" style="height: 410px;" *ngIf="subdelears.length > 0">
        <table class="table table-head-fixed text-nowrap" #assetsTable>
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact</th>
              <th>Firm Name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let delear of subdelears | filter: searchString: '' ">
              <td>{{ delear.name}}</td>
              <td>{{ delear.contact }}</td>
              <td>{{ delear.company_name }}</td>
              <td>
                <a class="btn" (click)="edit(delear)"><i class="fas fa-edit"></i></a>
                <a class="btn" (click)="info(delear)"><i class="fas fa-info"></i></a>
                <a class="btn" (click)="delete(delear)"
                *ngIf="currentUser.role === 'admin' || currentUser.role === 'manager' ">
                <i class="fas fa-trash"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<section class="content" *ngIf="!toggle">
  <form [formGroup]="delearForm" (ngSubmit)="onSubmit();" autocomplete="off">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-primary">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fa fa-arrow-left" style="margin-right: 8px;" (click)="back()"></i>
              Create new sub broker
            </h3>
          </div>
          <div class="card-body" style="display: block;">

            <div class="row">
              <div class="form-group col-md-6">
                <label for="name">Name</label>
                <input type="text" id="name" class="form-control" formControlName="name" required>
                <p *ngIf="delearForm.get('name').invalid" class="error">*name is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="company_name">Firm name</label>
                <input type="text" id="company_name" class="form-control" formControlName="company_name" required>
                <p *ngIf="delearForm.get('company_name').invalid" class="error">*firm is required</p>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="contact">Contact Number</label>
                <input type="tel" id="contact" class="form-control" formControlName="contact">
                <p *ngIf="delearForm.get('contact').invalid" class="error">*contact number is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="email">Email</label>
                <input type="email" id="email" class="form-control" formControlName="email">
                <p *ngIf="delearForm.get('email').invalid" class="error">*email is required</p>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="comission">Comission percentage</label>
                <input type="number" id="comission" class="form-control" formControlName="comission">
                <p *ngIf="delearForm.get('comission').invalid" class="error">*comission number is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="rera_number">Rera number</label>
                <input type="text" id="rera_number" class="form-control" formControlName="rera_number">
                <p *ngIf="delearForm.get('rera_number').invalid" class="error">*rera number is required</p>
              </div>
            </div>
            <div class="form-group">
              <label for="address">Address</label>
              <textarea id="address" class="form-control" rows="4" formControlName="address"></textarea>
              <p *ngIf="delearForm.get('address').invalid" class="error">*address is required</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <input type="submit" value="Create" class="btn btn-primary" *ngIf="!loading">

        <button class="btn btn-primary" type="button" disabled *ngIf="loading">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          creating...
        </button>

      </div>
    </div>
  </form>
</section>
